<template>
    <section v-if="course && course.cors">
        <Icon name="info" size="40" />
        <Txt size="m" heading>
            Course not available on this domain
        </Txt>
        <Txt>
            Whoops! This course won’t work here! To allow this domain to host this course, make sure it is listed in your SCORM security settings inside your Coassemble workspace.
        </Txt>
    </section>
    <section v-else-if="maintenance">
        <Icon name="info" size="40" />
        <Txt size="m" heading>
            Maintenance in progress
        </Txt>
        <Txt>
            We're currently performing maintenance on the platform. Please check back soon.
        </Txt>
    </section>
    <section v-else-if="collection">
        <Icon name="info" size="40" />
        <Txt size="m" heading>
            Collection no longer available
        </Txt>
        <Txt>
            Whoops! It looks like this collection is no longer available...
        </Txt>
    </section>
    <section v-else>
        <Icon name="info" size="40" />
        <Txt size="m" heading>
            Course no longer available
        </Txt>
        <Txt>
            Whoops! It looks like this course is no longer available...
        </Txt>
        <Txt v-if="!headless">
            Not to worry, you can always head over to <a href="//coassemble.com">Coassemble</a> and create your own! 😀
        </Txt>
    </section>
    <Button
        v-if="!headless && !$global.isPaid"
        variant="create"
        colour="translucent-dark"
        size="marker-s"
        hide-icon
        href="//coassemble.com"
        class="coassemble"
        slim
        target="_blank"
    >
        Made with
        <LogoMono />
    </Button>
</template>

<script>
import { useResponsive } from '@/store/responsive';

import Txt from '@/components/form/txt';
import Icon from '@/components/utility/icon';
import Button from '@/components/utility/button';

import LogoMono from '@/assets/CO_Logo_H_Mono.svg';

export default {
    name: 'CourseInactive',
    components: { Txt, Icon, Button, LogoMono },
    inject: ['$global'],
    props: {
        course: { type: Object, default: null },
        collection: { type: Object, default: null },

        error: { type: String, default: null },
        maintenance: { type: Boolean, default: false },
        headless: { type: Boolean, default: false }
    },
    data() {
        return {
            viewport: useResponsive()
        };
    },
    mounted() {
        this.postMessage({
            type: 'course',
            event: 'error',
            data: { error: this.error }
        });
    },
    methods: {
        postMessage(data) {
            if (!this.headless) return;
            if (window.self !== window.top) window.parent.postMessage(JSON.stringify(data), '*');
        }
    }
};
</script>

<style lang="less" scoped>
section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    gap: 16px;
    
    background: #FFFFFF;
    box-shadow: var(--shadow-base);
    border-radius: 24px;
    padding: 72px 32px;
    margin: auto;
    max-width: 504px;
    width: 100%;
    height: auto;
    > .icon {
        color: var(--primary);
        background-color: var(--primary-tint);
        padding: 12px;
        border-radius: 50%;
        align-self: center;
    }
    .field-container { flex: 1; }
    &.mobile {
        margin: 0;
        width: 100%;
        max-width: none;
        border-radius: 0;
    }
}
body {
    display: flex;
}
.coassemble.create {
    position: fixed;
    bottom: 0;
    margin: 24px;
    padding: 8px 16px;
    transition: all 0.25s var(--curve);
    svg {
        margin-left: 8px;
    }
}
</style>
